

export class Filter {
    branches: string[] = [];
    arts: string[] = [];
    schulisch: boolean = false;
    ausbildung: boolean = false;
    studium: boolean = false;
    companies: number[] = [];
}